export default {
      id: "switch-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#switch-usage",
      toString: function () {
        return this.url;
      }
    }